// extracted by mini-css-extract-plugin
module.exports = {"smooth":"_view_smooth__33mG2","filled":"_view_filled__f0--E"};